export function getExternalIdFromMongoId(id: string): number {
    const numbers = id.replace(/[^0-9]/g, '');
    const result = numbers.substring(numbers.length - 8);
    return Number(result);
}
